<template>
  <div>
    <div v-show="!loading">
      <h1>{{ $lang("TITLE_USER_PROFILE") }}</h1>
      <b-form ref="profile" @submit="onSubmit">
        <b-form-checkbox v-model="form.noChineseName">{{
          $lang("FIELD_NO_CHINESE_NAME")
          }}</b-form-checkbox>
        <div v-show="!form.noChineseName">
          <b-form-group>
            <slot name="lable">
              <span>{{ $lang("FIELD_LAST_NAME_ZH") }}</span><em class="necessary">*</em>
            </slot>
            <b-form-input type="text" v-model="form.firstNameZh" name="firstNameZh" :placeholder="$lang('請輸入姓氏')"
              :class="errors.has('firstNameZh') && 'is-invalid'"
              v-validate="{ required: !form.noChineseName, ChineseName: true }" />
            <b-form-invalid-feedback :state="errors.has('firstNameZh')">{{
              errors.first("firstNameZh")
              }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group>
            <slot name="lable">
              <span>{{ $lang("FIELD_FIRST_NAME_ZH") }}</span><em class="necessary">*</em>
            </slot>
            <b-form-input type="text" v-model="form.lastNameZh" name="lastNameZh" :placeholder="$lang('請輸入名字')"
              :class="errors.has('lastNameZh') && 'is-invalid'"
              v-validate="{ required: !form.noChineseName, ChineseName: true }" />
            <b-form-invalid-feedback :state="errors.has('lastNameZh')">{{
              errors.first("lastNameZh")
              }}</b-form-invalid-feedback>
          </b-form-group>
        </div>
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_LAST_NAME_PT") }}</span><em class="necessary">*</em>
          </slot>
          <b-form-input type="text" v-model="form.firstNamePt" name="firstNamePt" :placeholder="$lang('請輸入姓氏')"
            :class="errors.has('firstNamePt') && 'is-invalid'" v-validate="{ required: true, PtName: true }" />
          <b-form-invalid-feedback :state="errors.has('firstNamePt')">{{
            errors.first("firstNamePt")
            }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_FIRST_NAME_PT") }}</span><em class="necessary">*</em>
          </slot>
          <b-form-input type="text" v-model="form.lastNamePt" name="lastNamePt" :placeholder="$lang('請輸入名字')"
            :class="errors.has('lastNamePt') && 'is-invalid'" v-validate="{ required: true, PtName: true }" />
          <b-form-invalid-feedback :state="errors.has('lastNamePt')">{{
            errors.first("lastNamePt")
            }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_GENDER") }}</span><em class="necessary">*</em>
          </slot>
          <b-form-radio-group name="radio-inline" v-model="form.gender">
            <b-form-radio value="M">{{ $lang("FIELD_MALE") }}</b-form-radio>
            <b-form-radio value="F">{{ $lang("FIELD_FEMALE") }}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_BIRTHDAY") }}</span><em class="necessary">*</em>
          </slot>
          <b-input-group>
            <b-input-group-prepend>
              <i class="fa fa-calendar"></i>
            </b-input-group-prepend>
            <DatePicker :options="dpOptions" type="date" v-model="form.bornAt" name="bornAt" size="large"
              :class="errors.has('bornAt') && 'is-invalid'" v-validate="{ required: true, date_min_age: 18 }"
              format="yyyy/MM/dd"></DatePicker>
            <b-form-invalid-feedback :state="errors.has('bornAt')">{{
              errors.first("bornAt")
              }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>

        <!-- 证件类型 -->
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_ID_NUMBER_TYPE") }}</span><em class="necessary">*</em>
          </slot>
          <b-input-group>
            <b-form-select v-model="form.idType" name="idType" :class="errors.has('idType') && 'is-invalid'"
              v-validate="'required'">
              <option :value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
              <option :value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT") }}</option>
              <option :value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
            </b-form-select>
            <b-form-invalid-feedback :state="errors.has('idType')">{{
              errors.first("idType")
              }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>

        <!-- 证件号码 -->
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_ID_NUMBER") }}</span><em class="necessary">*</em>
          </slot>
          <b-form-input type="text" v-model="form.idNumber" name="idNumber"
            :class="errors.has('idNumber') && 'is-invalid'" v-validate="{ required: true, idNumber: isIdentity }"
            :placeholder="$lang('請輸入證件號碼')" />
          <b-form-invalid-feedback :state="errors.has('idNumber')">{{
            errors.first("idNumber")
            }}</b-form-invalid-feedback>
          <p>
            <span class="text-primary" v-html="$lang('HELP_BLOCK_ID_NUMBER')"></span>
          </p>
        </b-form-group>

        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_MOBILE") }}</span><em class="necessary">*</em>
          </slot>
          <b-input-group class="search-error">
            <b-input-group-prepend class="search-selete">
              <model-select :options="areaCodes" v-model="form.contact[0]" placeholder="select item"></model-select>
            </b-input-group-prepend>
            <b-form-input type="tel" v-model="form.contact[1]" name="phone" :class="errors.has('phone') && 'is-invalid'"
              v-validate="{ required: true, mobileV2: true }" :placeholder="$lang('FIELD_MOBILE')" />
            <b-form-invalid-feedback :state="errors.has('phone')">{{
              errors.first("phone")
              }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_NOTIFY_LANGUAGE") }}</span><em class="necessary">*</em>
          </slot>
          <b-form-select v-model="form.favouriteLanguage">
            <option value="zh_TW">{{ $lang("zh_TW") }}</option>
            <option value="en">{{ $lang("TEXT_LAN_EN") }}</option>
            <option value="pt_PT">{{ $lang("TEXT_LAN_PT_PT") }}</option>
          </b-form-select>
        </b-form-group>
        <b-form-group>
          <slot name="lable">
            <span>{{ $lang("FIELD_ADDRESS") }}</span>
          </slot>
          <b-form-textarea v-model="form.address" :placeholder="$lang('FIELD_ADDRESS')" rows="3"
            max-rows="6"></b-form-textarea>
        </b-form-group>
        <ladda-btn :loading="loginLoading" type="submit" data-style="expand-left"
          class="btn btn-info btn-round">&nbsp;&nbsp;{{ $lang("BTN_YES") }}&nbsp;&nbsp;</ladda-btn>
        <router-link to="../account" class="btn btn-info btn-round">&nbsp;&nbsp;{{
          $lang("TITLE_RETURN_INDEX")
        }}&nbsp;&nbsp;</router-link>
      </b-form>
    </div>
    <div class="spinner" v-show="loading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import LaddaBtn from "@/components/ladda/Ladda";
import { ModelSelect } from "vue-search-select";
export default {
  components: {
    LaddaBtn,
    ModelSelect,
  },
  data() {
    return {
      dpOptions: {
        disabledDate(date) {
          return date && date.valueOf() > new Date().valueOf();
        },
      },
      options: [
        {
          value: 1,
          text: "男",
        },
        {
          value: 2,
          text: "女",
        },
      ],
      documentType: [
        {
          value: "1",
          text: "身份證",
        },
        {
          value: "2",
          text: "護照",
        },
        {
          value: "3",
          text: "其他",
        },
      ],
      // show: false,
      loginLoading: false,
      loading: true,
      isIdentity: true,
      form: {
        address: "",
        bornAt: "",
        contact: ["+853", ""],
        favouriteLanguage: "zh_TW",
        firstNamePt: "",
        firstNameZh: "",
        gender: "M",
        idNumber: "",
        idType: 1,
        lastNamePt: "",
        lastNameZh: "",
        noChineseName: false,
      },
    };
  },
  created() {
    // 获取用户信息
    this.getUserInfo();
    this.$validator.extend('date_min_age', {
      getMessage: (field, params) => this.$lang(`必须年满18岁`),
      validate: (value, args) => {
        if (!value) return false;
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age >= args[0];
      }
    });
  },
  methods: {
    OnlyableChinese(e) {
      //限制只能输入中文
      var val = e.target;
      val.value = val.value.replace(/[^\u4E00-\u9FA5]/g, "");
    },
    disableChinese(e) {
      //限制不能输入中文
      var val = e.target;
      val.value = val.value.replace(/[\u4E00-\u9FA5]/g, "");
    },
    // 获取用户信息
    getUserInfo() {
      this.loading = true;

      $apis.user
        .getUserInfo()
        .then((resp) => {

          this.form = resp.data;
          this.$validator.reset();
          if (resp.data.contact.length == 0) {
            this.form.contact[0] = '+853'
          }

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 修改用户信息, params对应api body的结构
    updateUserInfo(params) {
      return $apis.user
        .updateUserInfo(params)
        .then((resp) => {
          if (resp.code === 0) {
            this.$router.push({
              name: "account",
              params: {
                dismissCountDown: 3,
              },
            });
          }
        })
        .catch((err) => {
          if (err.data.errors && err.data.errors.length > 0) {
            err.data.errors.forEach((item) => {
              this.validateErrors(item.path, item.message);
              this.notification.error(item.message);
            });
          } else {
            this.notification.error(err.message);
          }
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      return this.$validator.validate().then((result) => {
        this.form.bornAt = this.$changeTime(this.form.bornAt) || "";
        if (result) {
          this.loginLoading = true;
          this.updateUserInfo(this.form).finally(() => {
            this.loginLoading = false;
          });
        }
      });
    },
  },
  computed: {
    areaCodes() {
      return this.$store.getters["base/areaCodes"];
    },
  },
  watch: {
    "form.noChineseName": {
      handler(n) {
        if (n) {
          this.form.firstNameZh = "";
          this.form.lastNameZh = "";
          this.$validator.reset();
        }
      },
      immediate: true,
    },
    "form.idType": {
      handler(n) {
        if (n == 1) {
          this.isIdentity = true;
          console.log(this.isIdentity);
        } else {
          this.isIdentity = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
